const userCareMatrixProfilesSchema = [
  {
    profile_id: 'skill_development',
    profile_name: 'CP.PLATFORM.PROFILE.DEVELOP.TAG',
    description: 'CP.PLATFORM.PROFILE.DEVELOP.DESCRIPTION',
    variant: 'success',
  },
  {
    profile_id: 'preventive_care',
    profile_name: 'CP.PLATFORM.PROFILE.PREVENT.TAG',
    description: 'CP.PLATFORM.PROFILE.PREVENT.DESCRIPTION',
    variant: 'informative',
  },
  {
    profile_id: 'symptom_improvement',
    profile_name: 'CP.PLATFORM.PROFILE.TREAT.TAG',
    description: 'CP.PLATFORM.PROFILE.TREAT.DESCRIPTION',
    variant: 'attention',
  },
];

export const getCareMatrixProfile = (profileId: string) => {
  return userCareMatrixProfilesSchema.find(
    profile => profile.profile_id === profileId,
  );
};
